export default "__VITE_ASSET__B6Ytls8N__"